const LatestTickets = ({tickets}) => {

  const tableTemplate = ticket => {
    let total = 1;
    let win = true;
    return (
      <div className="col-md-6" key={ticket.id}>
        <table className="table latest-table text-center table-bordered">
          <thead>
          <tr>
            <td className="text-start">Event</td>
            <td>Type</td>
            <td>Odds</td>
            <td>State</td>
          </tr>
          </thead>
          <tbody>
          {ticket.tips.map(tip => {
            total = total * tip.odds;
            win = win && tip.status !== 'L';
            return (
              <tr className={'status-' + tip.status} key={tip.id}>
                <td className="text-start">{tip.data.home_name + ' vs ' + tip.data.away_name}</td>
                <td>{tip.data.short}</td>
                <td>{tip.odds}</td>
                <td className="loose-win">{tip.status}</td>
              </tr>
            )}
          )}
          <tr className={ticket.win_status ? 'tip-wins' : 'tip-losses'}>
            <td colSpan="2"><strong>Total</strong></td>
            <td><strong>{total.toFixed(2)}</strong></td>
            <td className="loose-win"><strong>{win ? 'W' : 'L'}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    )
  };
  if(tickets.length === 0) {
    return <></>
  }

  tickets.forEach(t => {
    if(typeof t.tips === 'string') t.tips = JSON.parse(t.tips)
  })

  return (
    <>
      <div className="row">
        <h2>Tickets</h2>
        {tickets.map(ticket => tableTemplate(ticket))}
      </div>
    </>
  );
}

export default LatestTickets
